import { TranslationType } from '../components/HbtPortfolioManagementTable/types';
import { occupancyMapping } from './OccupancyMapping';

export const getOccupancyTypeLabel = (
  occupancyType: keyof typeof occupancyMapping | string,
  t: TranslationType
) => {
  return occupancyMapping(t)[occupancyType as never];
};
